import { render, staticRenderFns } from "./AdminTrainViewLayout.vue?vue&type=template&id=4605400f&scoped=true"
import script from "./AdminTrainViewLayout.vue?vue&type=script&lang=js"
export * from "./AdminTrainViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605400f",
  null
  
)

export default component.exports